<flw-list
  (refresh)="refresh($event)"
  [loading]="loading"
  [pageRoute]="pageRoute"
  [page]="page"
  [records]="records"
  [totalItems]="totalItems"
>
  <flw-filter
    (applyFilter)="applyFilter($event)"
    (cancelFilter)="cancelFilter()"
    (exportFilter)="exportFilter($event)"
    [clearSearch]="clearSearch"
    [filters]="filters"
    [pageName]="pageName"
    [pageRoute]="pageRoute"
    [showAddButton]="true"
    [showSearch]="true"
    page-filter
  >
  </flw-filter>
  <tr [(ascending)]="reverse" [(predicate)]="predicate" jhiSort (sortChange)="sortChange($event)" table-headers>
    <th class="td-status" scope="col">
      <span [jhiSortBy]="'programEnum'">
        <span jhiTranslate="app.programGeneralInformation.programEnum">Program Enum</span>
        <fa-icon [icon]="'sort'"></fa-icon>
      </span>
      <br />
      <span [jhiSortBy]="'programModality'">
        <span jhiTranslate="app.programGeneralInformation.programModality">Program Modality</span>
        <fa-icon [icon]="'sort'"></fa-icon>
      </span>
    </th>
    <th [jhiSortBy]="'position'" scope="col">
      <span jhiTranslate="app.programNews.position">Position</span>
      <fa-icon [icon]="'sort'"></fa-icon>
    </th>
    <th [jhiSortBy]="'titlePT'" scope="col">
      <span jhiTranslate="app.programNews.titlePT">Title PT</span>
      <fa-icon [icon]="'sort'"></fa-icon>
    </th>
    <th [jhiSortBy]="'active'" scope="col">
      <span jhiTranslate="app.programNews.active">Active</span>
      <fa-icon [icon]="'sort'"></fa-icon>
    </th>
    <th [jhiSortBy]="'startDate'" scope="col">
      <span jhiTranslate="app.programNews.startDate">Start Date</span>
      <fa-icon [icon]="'sort'"></fa-icon>
    </th>
    <th [jhiSortBy]="'endDate'" scope="col">
      <span jhiTranslate="app.programNews.endDate">End Date</span>
      <fa-icon [icon]="'sort'"></fa-icon>
    </th>
    <th [jhiSortBy]="'editedDate'" scope="col">
      <span jhiTranslate="app.programNews.editedDate">Edited Date</span>
      <fa-icon [icon]="'sort'"></fa-icon>
    </th>
    <th scope="col"></th>
  </tr>
  <tr *ngFor="let record of records; trackBy: trackId" table-lines>
    <td class="td-status">
      <span class="badge d-block" jhiTranslate="{{ 'app.ProgramEnum.' + record.programEnum }}">{{ record.programEnum }}</span>
      <span class="badge d-block" jhiTranslate="{{ 'app.ProgramModality.' + record.programModality }}">{{ record.programModality }}</span>
    </td>
    <td>{{ record.position }}</td>
    <td>{{ record.titlePT }}</td>
    <td>{{ record.active }}</td>
    <td>{{ record.startDate | formatMediumDate }}</td>
    <td>{{ record.endDate | formatMediumDate }}</td>
    <td>{{ record.editedDate | formatMediumDate }}</td>
    <td>
      <flw-list-buttons
        (delete)="delete($event)"
        [pageRoute]="pageRoute"
        [record]="record"
        [showDelete]="true"
        [showEdit]="true"
        [showView]="false"
      ></flw-list-buttons>
    </td>
  </tr>
</flw-list>
